import React, { useState } from 'react';
import {
  Box, TextField, Button, Typography, CircularProgress, Paper,
  FormControl, InputLabel, Select, MenuItem, Stack
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { useCreateWholesaleInventory } from './wholesaleinventory.hooks';
import { useNavigate } from 'react-router-dom';
export default function AddWholesaleLoad() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({

    file: null,
  });
  const {
    mutate,
    isLoading: isSubmitting,
  } = useCreateWholesaleInventory(
    () => {
      dispatch(showAlert({ severity: 'success', title: 'Inventory updated successfully!' }));
      navigate('/wholesaleinventory/manage');
    },
    (error) => {
      dispatch(showAlert({
        severity: 'error',
        title: error?.response?.data?.message || 'Inventory updation failed, Try later'
      }));
    }
  );


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const allowedTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];
    const isXls = /\.(xlsx|xls)$/i.test(file.name) && allowedTypes.includes(file.type);
  
    if (!isXls) {
      dispatch(showAlert({
        severity: 'error',
        title: `Only .xls/.xlsx files are allowed. Detected: ${file.type}`,
      }));
      return;
    }
  
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (file.size > maxSize) {
      dispatch(showAlert({
        severity: 'error',
        title: 'File size must be less than 2MB.',
      }));
      return;
    }
  
    setFormData((prev) => ({ ...prev, file }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    mutate(formData);
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 500, mx: 'auto', mt: 6 }}>
      <Typography variant="h5" gutterBottom>Update Inventory</Typography>

      {isSubmitting && <CircularProgress />}

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Stack spacing={3}>


          <Button variant="outlined" component="label">
            Upload .xls File
            <input
              type="file"
              hidden
              accept=".xls,.xlsx"
              onChange={handleFileChange}
            />
          </Button>

          {formData.file && (
            <Typography variant="body2">
              Selected File: {formData.file.name}
            </Typography>
          )}

          <Button type="submit" variant="contained" fullWidth disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={24} /> : 'Update Inventory'}
          </Button>
        </Stack>
      </Box>
    </Paper>
  );
}
